import { param } from "jquery";
import client from "./serviceClient";

const fetchAssessmentDocuments = params =>
  client.post(`/prospectAssessment/document-collection/fetch-documents`, { ...params });

const setFacilityType = params =>
  client.post(`/prospectAssessment/document-collection/set-facility-type`, { ...params });

const fetchAssessmentRequests = params =>
  client.post(`/prospectAssessment/document-collection/fetch-requests`, { ...params });

const generateAssessmentDocumentLink = params =>
  client.post(`/prospectAssessment/document-collection/generate-link`, { ...params });

const sendAssessmentDocumentLink = params =>
  client.post(`/prospectAssessment/document-collection/send-link`, { ...params });

const invalidateAssessmentDocumentLink = params =>
  client.post(`/prospectAssessment/document-collection/invalidate-link`, { ...params });

const downloadAllAssessmentDocuments = params =>
  client.post(`/prospectAssessment/document-collection/download-all-documents`, { ...params });

const prepareLinkEmail = params =>
  client.post(`/prospectAssessment/document-collection/prepare-link-email`, { ...params });

const listOnedriveFolders =params =>
  client.post("/prospectAssessment/document-collection/list-onedrive-folders", {...params});

const moveDocumentsToOnedrive = params =>
  client.post("/prospectAssessment/document-collection/move-documents", {...params});

const getDocumentCollectionAuditTrail = params => 
  client.post("/audittrail/audit-trail/document-collection-audit", {...params});

const createInfotrackOrder = params =>
  client.post(`/prospectAssessment/document-collection/create-infotrack-order`, { ...params });

const fetchInfotrackOrder = params =>
  client.post(`/prospectAssessment/document-collection/fetch-infotrack-order`, { ...params });

const checkInfotrackStatus = params =>
  client.post(`/prospectAssessment/document-collection/check-infotrack-status`, { ...params });


const resendInfotrackEmail = params =>
  client.post(`/prospectAssessment/document-collection/resend-infotrack-email`, { ...params });

const fetchCollectionReport = params =>
  client.post(`/prospectAssessment/document-collection/fetch-collection-report`, { ...params });

const updateReceiverEmail = params =>
  client.post(`/prospectAssessment/document-collection/update-receiver-email`, { ...params });

const fetchProspectContacts = params =>
  client.post(`/prospectAssessment/document-collection/list-prospect-contacts`, { ...params });

const fetchInfotrackPhoto = params =>
  client.post(`/prospectAssessment/document-collection/fetch-infotrack-photo`, { ...params });

const downloadInfotrackReport = params =>
  client.post(`/prospectAssessment/document-collection/download-infotrack-report`, {...params });

const listInfotrackContacts = params =>
  client.post(`/prospectAssessment/document-collection/list-infotrack-contacts`, { ...params });



/* Public Upload Portal */

const resolveUploadToken = params =>
  client.post(`/prospectAssessment/document-upload/resolve-token`, { ...params });

const uploadAssessmentDocuments = params =>
  client.post(`/prospectAssessment/document-upload/upload-documents`, { ...params });

const verifyEmail = params =>
  client.post(`/prospectAssessment/document-upload/verify-email`, { ...params });


const sendOtp = params =>
  client.post(`/prospectAssessment/document-upload/send-otp`, { ...params });

const verifyOtp = params =>
  client.post(`/prospectAssessment/document-upload/verify-otp`, { ...params });

const fetchUploadChecklist = params =>
  client.post(`/prospectAssessment/document-upload/fetch-checklist`, { ...params });


export default {
  fetchAssessmentRequests,
  fetchAssessmentDocuments,
  setFacilityType,
  generateAssessmentDocumentLink,
  sendAssessmentDocumentLink,
  invalidateAssessmentDocumentLink,
  downloadAllAssessmentDocuments,
  prepareLinkEmail,
  updateReceiverEmail,
  fetchProspectContacts,

  createInfotrackOrder,
  fetchInfotrackOrder,
  checkInfotrackStatus,
  resendInfotrackEmail,

  listOnedriveFolders,
  moveDocumentsToOnedrive,

  fetchInfotrackPhoto,
  downloadInfotrackReport,
  listInfotrackContacts,

  fetchCollectionReport,

  getDocumentCollectionAuditTrail,

  resolveUploadToken,
  uploadAssessmentDocuments,
  verifyEmail,
  sendOtp,
  verifyOtp,
  fetchUploadChecklist,
};